import { render, staticRenderFns } from "./SeyirVehicleDetailReport.vue?vue&type=template&id=2f984ae1&"
import script from "./SeyirVehicleDetailReport.vue?vue&type=script&lang=js&"
export * from "./SeyirVehicleDetailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports